/* eslint-disable func-names */
import {
    INITIATE_APPLICATION,
    FETCH_APPLICATIONS,
    GET_SCHEMA,
    UPDATE_SCHEMA,
    LOGIN_USER,
    SIGNATORY_REVIEW,
    GET_APPLICATION,
    FETCH_REVIEWED_APPLICATIONS,
    CLEAR_APPLICATION_DETAILS,
    GET_ACCESSAREAS,
    BADGE_REAPPLY,
    INITIATE_BADGE_DELETE,
    REJECT_BADGE,
    RENEWAL_APPLICATION,
    EDIT_APPLICATION
  } from './types';

  import { actionForState } from '../../../utils/helpers';

  const INITIAL_STATE = {
    error: {},
    action: {
      loading: false,
      success: undefined
    },
    InitiateApplicationAction: {
      loading: false, success: false, error: false
    },
    fetchApplicationAction: {
      loading: false, success: false, error: false
    },
    fetchReviewedApplicationAction: {
      loading: false, success: false, error: false
    },
    LoginUserAction: {
      loading: false, success: false, error: false
    },
    accessAreaAction: {
      loading: false, success: false, error: false
    },
    deleteAction: {
      loading: false,
      success: false,
      error: false
    },
    saveSignatoryAction: {
      loading: false,
      success: false,
      error: false
    },
    RenewalApplicationAction: {
      loading: false, success: false, error: false
    }
  };

  export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
      case INITIATE_APPLICATION.pending:
        return {
          ...state,
          InitiateApplicationAction: actionForState(state.action, 'pending')
        };
      case INITIATE_APPLICATION.success:
        return {
          ...state,
          InitiateApplicationAction: actionForState(state.action, 'success'),
          initiated_data: action.payload
        };
      case INITIATE_APPLICATION.error:
        if (action.payload.request.status === 400) {
          return {
            ...state,
            errormsg: action.payload.response.data,
            InitiateApplicationAction: actionForState(state.action, 'error')
          };
        }
        return {
          ...state,
          errormsg: action.payload.response?.data,
          InitiateApplicationAction: actionForState(state.action, 'error')
        };
      case REJECT_BADGE.pending:
          return {
            ...state,
            badgeReject: actionForState(state.action, 'pending')
          };
      case REJECT_BADGE.success:
          return {
            ...state,
            badgeReject: actionForState(state.action, 'success')
          };
      case REJECT_BADGE.error:
          return {
            ...state,
            badgeReject: actionForState(state.action, 'error')
          };
      case GET_ACCESSAREAS.pending:
        return {
          ...state,
          accessAreaAction: actionForState(state.action, 'pending')
        };
        case GET_ACCESSAREAS.success:
          return {
          ...state,
          accessAreas: action.payload,
          accessAreaAction: actionForState(state.action, 'pending')
        };
        case GET_ACCESSAREAS.error:
        return {
          ...state,
          accessAreaAction: actionForState(state.action, 'error')
        };
      case FETCH_APPLICATIONS.pending:
        return {
          ...state,
          fetchApplicationAction: actionForState(state.action, 'pending')
        };
      case FETCH_APPLICATIONS.success:
        return {
          ...state,
          fetchApplicationAction: actionForState(state.action, 'success'),
          applications: action.payload
        };
      case FETCH_APPLICATIONS.error:
        return {
          ...state,
          fetchApplicationAction: actionForState(state.action, 'error')
        };
      case FETCH_REVIEWED_APPLICATIONS.pending:
        return {
          ...state,
          fetchReviewedApplicationAction: actionForState(state.action, 'pending')
        };
      case FETCH_REVIEWED_APPLICATIONS.success:
        return {
          ...state,
          fetchReviewedApplicationAction: actionForState(state.action, 'success'),
          reviewed_applications: action.payload
        };
      case FETCH_REVIEWED_APPLICATIONS.error:
        return {
          ...state,
          fetchReviewedApplicationAction: actionForState(state.action, 'error')
        };
      case GET_SCHEMA.pending:
        return {
          ...state,
          action: actionForState(state.action, 'pending')
        };
      case GET_SCHEMA.success:
        return {
          ...state,
          action: actionForState(state.action, 'success'),
          schema: action.payload
        };
      case GET_SCHEMA.error:
        return {
          ...state,
          action: actionForState(state.action, 'error')
        };
      case UPDATE_SCHEMA.pending:
        return {
          ...state,
          action: actionForState(state.action, 'pending')
        };
      case UPDATE_SCHEMA.success:
        return {
          ...state,
          action: actionForState(state.action, 'success')
          // schema: action.payload
        };
      case UPDATE_SCHEMA.error:
        return {
          ...state,
          action: actionForState(state.action, 'error')
        };
      case LOGIN_USER.pending:
        return {
          ...state,
          LoginUserAction: actionForState(state.action, 'pending')
        };
      case LOGIN_USER.success:
        return {
          ...state,
          LoginUserAction: actionForState(state.action, 'success'),
          user_data: action.payload
        };
      case LOGIN_USER.error:
        return {
          ...state,
          LoginUserAction: actionForState(state.action, 'error')
        };
      case SIGNATORY_REVIEW.pending:
        return {
          ...state,
          saveSignatoryAction: actionForState(state.action, 'pending')
        };
      case SIGNATORY_REVIEW.success:
        return {
          ...state,
          saveSignatoryAction: actionForState(state.action, 'success')
        };
      case SIGNATORY_REVIEW.error:
        return {
          ...state,
          saveSignatoryAction: actionForState(state.action, 'error')
        };
      case GET_APPLICATION.pending:
        return {
          ...state,
          fetchApplicationAction: actionForState(state.action, 'pending')
        };
      case GET_APPLICATION.success:
        return {
          ...state,
          fetchApplicationAction: actionForState(state.action, 'success'),
          applicationdata: action.payload
        };
      case GET_APPLICATION.error:
        return {
          ...state,
          fetchApplicationAction: actionForState(state.action, 'error')
        };

        case EDIT_APPLICATION.pending:
        return {
          ...state,
          editApplicationAction: actionForState(state.action, 'pending')
        };
      case EDIT_APPLICATION.success:
        return {
          ...state,
          editApplicationAction: actionForState(state.action, 'success'),
          applicationdata: action.payload
        };
      case EDIT_APPLICATION.error:
        return {
          ...state,
          editApplicationAction: actionForState(state.action, 'error')
        };

      case BADGE_REAPPLY.pending:
        return {
          ...state,
          ReApplicationAction: actionForState(state.action, 'pending')
        };
      case BADGE_REAPPLY.success:
        return {
          ...state,
          ReApplicationAction: actionForState(state.action, 'success'),
          reApplied_data: action.payload
        };
      case BADGE_REAPPLY.error:
        if (action.payload.request.status === 400) {
          return {
            ...state,
            errormsg: action.payload.response.data,
            ReApplicationAction: actionForState(state.action, 'error')
          };
        }
        return {
          ...state,
          errormsg: action.payload.response.data,
          ReApplicationAction: actionForState(state.action, 'error')
        };
        case INITIATE_BADGE_DELETE.pending:
          return {
            ...state,
            deleteAction: actionForState(state.action, 'pending')
          };
        case INITIATE_BADGE_DELETE.success:
          return {
            ...state,
            deleteAction: actionForState(state.action, 'success')
          };
        case INITIATE_BADGE_DELETE.error:
          return {
            ...state,
            deleteAction: actionForState(state.action, 'error')
          };
      case CLEAR_APPLICATION_DETAILS:
        return {
          ...state,
          // applicationdata: {},
          applications: [],
          reviewed_applications: [],
          applicationDetailAction: {
            loading: false, success: false, error: false
          },
          fetchApplicationAction: {
            loading: false, success: false, error: false
          },
          editApplicationAction: {
            loading: false, success: false, error: false
          },
          fetchReviewedApplicationAction: {
            loading: false, success: false, error: false
          },
          deleteAction: {
            success: false, loading: false, error: false
          }
        };
      case RENEWAL_APPLICATION.pending:
        return {
          ...state,
          RenewalApplicationAction: actionForState(state.action, 'pending')
        };
      case RENEWAL_APPLICATION.success:
        return {
          ...state,
          RenewalApplicationAction: actionForState(state.action, 'success'),
          Renewal_data: action.payload
        };
      case RENEWAL_APPLICATION.error:
        if (action.payload.request.status === 400) {
          return {
            ...state,
            errormsg: action.payload.response.data,
            RenewalApplicationAction: actionForState(state.action, 'error')
          };
        }
        return {
          ...state,
          errormsg: action.payload.response?.data,
          RenewalApplicationAction: actionForState(state.action, 'error')
        };
      default:
        return state;
    }
  }
